import { render, staticRenderFns } from "./AddInventoryItemCatalogDrawer.vue?vue&type=template&id=cf8b7396"
import script from "./AddInventoryItemCatalogDrawer.vue?vue&type=script&lang=js"
export * from "./AddInventoryItemCatalogDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports